import { StepType, useTour } from '@reactour/tour';
import { useProvider } from 'utils/providers/Provider';
import Content from 'ui/components/common/Tour/Content';
import { TOUR_SELECTOR } from 'ui/partials/Tour';

const useGetHowToCreateLeadSteps = () => {
  const { dispatch, state } = useProvider();
  const { setIsOpen, setSteps, setCurrentStep } = useTour();
  const isCollapsed = state?.collapse;

  const generalCreateLeadSteps: StepType[] = [
    {
      content: 'Go to the Contacts menu tab',
      selector: `[data-tut="${TOUR_SELECTOR.TOUR.CONTACT.MENU}"]`,
      action: (node) => {
        node?.addEventListener(
          'click',
          function () {
            setTimeout(() => setCurrentStep(1), 800);
          },
          false,
        );
      },
      disableActions: true,
      styles: {
        arrow: (base) => ({
          ...base,
          visibility: 'hidden',
        }),
      },
      position: 'right',
    },
    {
      content: 'Then select Leads to view the Leads page',
      position: 'right',
      selector: `[data-tut="${TOUR_SELECTOR.TOUR.CONTACT.LEAD.SUBMENU}"]`,
      action: (node) => {
        node?.addEventListener(
          'click',
          function () {
            setTimeout(() => setCurrentStep(2), 800);
          },
          false,
        );
      },
      disableActions: false,
      styles: {
        popover: (base) => ({ ...base, marginLeft: 11 }),
      },
    },
    {
      content: 'On the Leads page, click on the Create Lead button',
      selector: `[data-tut="${TOUR_SELECTOR.TOUR.CONTACT.LEAD.FORM.CREATE_BUTTON}"]`,
      action: (node) => {
        node?.addEventListener(
          'click',
          function () {
            setTimeout(() => setCurrentStep(3), 800);
            // setIsOpen(false);
          },
          false,
        );
      },
      position: 'bottom',
    },
    {
      content: (props) => (
        <Content
          {...props}
          content={
            // eslint-disable-next-line max-len
            "Fill out the form with the lead's information, such as name, email, phone number, company, website, and address."
          }
        />
      ),
      selector: `[data-tut="${TOUR_SELECTOR.TOUR.CONTACT.LEAD.FORM.FORM}"]`,
      highlightedSelectors: [
        '[data-tut="Modal__Header"]',
        `[data-tut="${TOUR_SELECTOR.TOUR.CONTACT.LEAD.FORM.FORM}"]`,
      ],
      disableActions: false,
      action: (node) => {
        node?.addEventListener(
          'click',
          function () {
            setTimeout(() => setCurrentStep(4), 1000);
          },
          false,
        );
      },
      position: 'right',
    },
    {
      content: 'Click Save and you are done.',
      selector: `[data-tut="${TOUR_SELECTOR.TOUR.CONTACT.LEAD.FORM.SAVE_BUTTON}"]`,
      action: (node: any) => {
        node?.addEventListener(
          'click',
          function () {
            setCurrentStep(0);
            setSteps?.([]);
          },
          false,
        );
      },
      position: 'top',
      styles: {
        popover: (base) => ({ ...base, top: -8 }),
      },
    },
  ];

  const showCreateLeadSteps = () => {
    if (isCollapsed) {
      dispatch?.({ type: 'toggleSidebar' });
    }

    setTimeout(() => {
      setSteps?.(generalCreateLeadSteps);
      setIsOpen(true);
    }, 200);
  };

  return showCreateLeadSteps;
};

export default useGetHowToCreateLeadSteps;
